import dayjs from "dayjs";

import { shortMonthAndShortYear } from "@similarweb/pro-logic-components";

import { translate } from "app/filters/i18nFilter";
import type { IRankDistributionOverTimeData } from "app/pages/keyword-research/website-analysis/pages/seo-overview/types";
import { abbrNumberFilter } from "app/filters/ngFilters";

import { positionsConfig } from "./RankingDistributionGraphConsts";
import type { ITransformedItem } from "./RankingDistributionGraphTypes";

export const yAxisFormatter = ({ value }) => abbrNumberFilter()(value, true);
export const xAxisFormatter = ({ value }) => dayjs.utc(value).format(shortMonthAndShortYear);

export function transformData(inputData: IRankDistributionOverTimeData): ITransformedItem[] {
    const seriesData: Record<string, ITransformedItem> = {};

    Object.entries(positionsConfig).forEach(([position, config]) => {
        seriesData[position] = {
            id: position,
            name: `${translate("seo.overview.ranking.distributoin.graph.legend.title")} ${config.name}`,
            color: config.color,
            data: [],
            visible: true,
        };
    });

    // Populate seriesData with inputData
    Object.entries(inputData?.monthlyDistributions).forEach(([month, positions]) => {
        const monthTimestamp = dayjs.utc(month).valueOf();
        Object.entries(positions).forEach(([position, details]) => {
            if (seriesData[position]) {
                seriesData[position].data.push([monthTimestamp, details.keywordCount]);
            }
        });
    });

    return Object.values(seriesData).map((series) => ({
        ...series,
        data: series.data.sort((a, b) => a[0] - b[0]), // Sort timestamps in ascending order
        visible: true,
    }));
}
